var _g, _path, _path2, _path3, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewieLogoTekstDonker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 496.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#81358A",
    d: "M316.4,337.3L334.5,159c0-14.2-12-25.8-26.8-25.8L89.5,119.2c-15.8,0-28.6,12.3-28.6,27.5l17.2,203.8 c0,14.2,12,25.8,26.8,25.8l181.7-10.4C303,365.9,316.4,353.1,316.4,337.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 197.7209,
    cy: 247.7442,
    r: 225.198,
    fx: 239.2801,
    fy: 65.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003991564,
    style: {
      stopColor: "#0086BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7077,
    style: {
      stopColor: "#0086BF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M316.4,337.3L334.5,159c0-14.2-12-25.8-26.8-25.8L89.5,119.2c-15.8,0-28.6,12.3-28.6,27.5 l17.2,203.8c0,14.2,12,25.8,26.8,25.8l181.7-10.4C303,365.9,316.4,353.1,316.4,337.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 197.7209,
    cy: 247.7442,
    r: 225.198,
    fx: 367.876,
    fy: 263.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    style: {
      stopColor: "#E9755C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5044,
    style: {
      stopColor: "#E9755C",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M316.4,337.3L334.5,159 c0-14.2-12-25.8-26.8-25.8L89.5,119.2c-15.8,0-28.6,12.3-28.6,27.5l17.2,203.8c0,14.2,12,25.8,26.8,25.8l181.7-10.4 C303,365.9,316.4,353.1,316.4,337.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 73.2816,
    cy: 256.4727,
    r: 204.9955,
    fx: -13.6438,
    fy: 216.3542,
    gradientTransform: "matrix(0.866 -0.5 0.6893 1.1939 -166.9739 -13.0988)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4602,
    style: {
      stopColor: "#CE007F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8374,
    style: {
      stopColor: "#CE007F",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M316.4,337.3L334.5,159 c0-14.2-12-25.8-26.8-25.8L89.5,119.2c-15.8,0-28.6,12.3-28.6,27.5l17.2,203.8c0,14.2,12,25.8,26.8,25.8l181.7-10.4 C303,365.9,316.4,353.1,316.4,337.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M468.6,192.7l-27.1,75.8h-21.6l-27.1-75.8h20.9l17,51.6l17-51.6L468.6,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M488.9,160.9c6.7,0,11.9,5,11.9,11.6s-5.2,11.6-11.9,11.6s-11.9-5-11.9-11.6S482.1,160.9,488.9,160.9z  M478.8,192.7h20.1l0,75.8h-20.1V192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M555.7,254.2c10.4,0,17.8-3.5,24.9-10.2l10.1,10.1c-8.3,9.4-19.2,16.1-35,16.1 c-25.9,0-43.1-17.5-43.1-39.6s17.7-39.6,41.2-39.6c23.2,0,39.7,17.2,39.7,38.3c0,2.3-0.4,5.3-0.9,7.3l-59.7,0 C534.8,247.1,543.5,254.2,555.7,254.2z M533.5,222.2l39.3,0c-2.2-9-9.4-15.3-19.2-15.3C544.2,206.9,536.2,213,533.5,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M664.7,192.7l13,50.7l13.2-50.7l20.5,0l-23,75.8h-20.8l-13.2-49.3l-13.2,49.3l-20.8,0l-23-75.8l20.5,0 l13.2,50.7l13-50.7L664.7,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M731.9,160.9c6.7,0,11.9,5,11.9,11.6s-5.2,11.6-11.9,11.6c-6.7,0-11.9-5-11.9-11.6 C720,165.9,725.2,160.9,731.9,160.9z M721.8,192.7h20.1v75.8l-20.1,0L721.8,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M798.7,254.2c10.4,0,17.8-3.5,24.9-10.2l10.1,10.1c-8.3,9.4-19.2,16.1-35,16.1 c-25.9,0-43.1-17.5-43.1-39.6s17.7-39.6,41.2-39.6c23.2,0,39.7,17.2,39.7,38.3c0,2.3-0.4,5.3-0.9,7.3l-59.7,0 C777.8,247.1,786.6,254.2,798.7,254.2z M776.6,222.2l39.3,0c-2.2-9-9.4-15.3-19.2-15.3C787.2,206.9,779.3,213,776.6,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1017.8,221.6l0,46.9l-20.1,0v-44.8c0-8.4-5.5-15-13.2-15c-8.6,0-16.5,7.1-16.5,18.5l0,41.2h-20.1v-44.8 c0-8.4-5.5-15-13.2-15c-8.6,0-16.5,7.1-16.5,18.5v41.2h-20.1v-75.8h20.1v8.3c5.3-6.3,12.6-10.1,20.8-10.1 c11.1,0,20.6,5.8,25.4,15.3c5.2-9.4,14-15.3,24.4-15.3C1005.2,190.9,1017.8,203.2,1017.8,221.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1074,254.2c10.4,0,17.8-3.5,24.9-10.2l10.1,10.1c-8.3,9.4-19.2,16.1-35,16.1 c-25.9,0-43.1-17.5-43.1-39.6s17.7-39.6,41.2-39.6c23.2,0,39.7,17.2,39.7,38.3c0,2.3-0.4,5.3-0.9,7.3l-59.7,0 C1053.1,247.1,1061.9,254.2,1074,254.2z M1051.9,222.2l39.3,0c-2.2-9-9.4-15.3-19.2-15.3C1062.5,206.9,1054.6,213,1051.9,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1158.2,190.9c10.6,0,19.2,4.1,25.2,10.8v-40.1h19.9l0,106.8l-19.9,0v-9.1c-6.1,6.7-14.6,10.8-25.2,10.8 c-21.1,0-36.6-17.5-36.6-39.6S1137,190.9,1158.2,190.9z M1162.5,252.4c11.7,0,20.9-9.5,20.9-21.9c0-12.3-9.2-21.9-20.9-21.9 c-11.6,0-20.7,9.6-20.7,21.9C1141.8,242.9,1150.8,252.4,1162.5,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1232.4,160.9c6.7,0,11.9,5,11.9,11.6s-5.2,11.6-11.9,11.6c-6.7,0-11.9-5-11.9-11.6 S1225.7,160.9,1232.4,160.9z M1222.3,192.7h20.1l0,75.8h-20.1V192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1292.8,190.9c10.6,0,19.2,4.1,25.2,10.8v-9.1h19.9v75.8H1318v-9.1c-6.1,6.7-14.6,10.8-25.2,10.8 c-21.1,0-36.6-17.5-36.6-39.6S1271.7,190.9,1292.8,190.9z M1297.1,252.4c11.7,0,20.9-9.5,20.9-21.9c0-12.3-9.2-21.9-20.9-21.9 c-11.6,0-20.7,9.6-20.7,21.9C1276.4,242.9,1285.5,252.4,1297.1,252.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M420,325.5c2.2,2.5,5.3,4.5,8.8,4.5c4.6,0,7.9-2.4,7.9-6c0-3.3-2.5-5.7-8.3-6.9c-6.5-1.3-9.9-4.5-9.9-8.9 c0-5,4-8.5,9.9-8.5c5.3,0,10.1,2.7,10.8,8.6H436c-0.5-3.8-3.6-5.8-7.3-5.8c-4.1,0-6.8,2.3-6.8,5.4c0,3.3,2.8,5.4,8,6.5 c7.1,1.6,10.2,4.8,10.2,9.5c0,5.1-4.3,8.9-11,8.9c-4.5,0-8.1-2.2-10.7-5.5L420,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M474.5,327.8L462,306.5v25.8l-3.1,0v-32.1h3l13.6,23.1l13.5-23.1h3v32.1h-3.1v-25.8l-12.5,21.3H474.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M534.1,332.3l-3.3-8.8h-14.7l-3.3,8.8h-3.5l12.4-32.1h3.5l12.4,32.1H534.1z M529.8,320.7l-6.4-16.9 l-6.4,16.9H529.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M558.2,319.7v12.6H555v-32.1h9.7c6.7,0,11,3.9,11,9.8c0,5.2-3.3,8.8-8.5,9.6l9.1,12.8h-3.6l-8.9-12.6 H558.2z M564.6,303h-6.4v13.9l6.4,0c4.8,0,7.8-2.8,7.8-7C572.4,305.7,569.4,303,564.6,303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M600.5,303h-9.4v-2.8h22v2.8h-9.4l0,29.3h-3.2V303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M668.3,300.2c9.5,0,15.5,6.4,15.5,16.1c0,9.7-6,16.1-15.5,16.1h-10.5v-32.1L668.3,300.2z M661,303v26.4 h7.3c7.3,0,12.3-4.9,12.3-13.2c0-8.3-4.9-13.2-12.3-13.2H661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M706.3,300.2v32.1H703v-32.1H706.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M752.8,310.5c-1.5-4.9-6.2-8-11.5-8c-6.8,0-12.8,5.5-12.8,13.7c0,8.1,6.1,13.8,13.1,13.8 c6.7,0,11.3-4.8,11.8-11.3l-12.2,0V316h15.6v0.7c0,9.8-6.2,16.2-15.2,16.2c-9,0-16.3-7.2-16.3-16.6c0-9.6,7.1-16.6,16-16.6 c7.7,0,13.4,4.6,15,10.8H752.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M779.1,300.2v32.1h-3.2v-32.1H779.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M806.3,303h-9.4v-2.8h22v2.8h-9.4v29.3h-3.2V303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M855,332.3l-3.3-8.8H837l-3.3,8.8l-3.5,0l12.4-32.1h3.5l12.4,32.1H855z M850.7,320.7l-6.4-16.9l-6.4,16.9 H850.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M875.8,300.2h3.2v29.3h15.1v2.8h-18.4L875.8,300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M939.2,325.5c2.2,2.5,5.3,4.5,8.8,4.5c4.6,0,7.9-2.4,7.9-6c0-3.3-2.5-5.7-8.3-6.9 c-6.5-1.3-9.9-4.5-9.9-8.9c0-5,4-8.5,9.9-8.5c5.3,0,10.1,2.7,10.8,8.6h-3.3c-0.5-3.8-3.6-5.8-7.3-5.8c-4.1,0-6.8,2.3-6.8,5.4 c0,3.3,2.8,5.4,8,6.5c7.1,1.6,10.2,4.8,10.2,9.5c0,5.1-4.3,8.9-11,8.9c-4.5,0-8.1-2.2-10.7-5.5L939.2,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M981.7,300.2v32.1h-3.2v-32.1H981.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1028.3,310.5c-1.5-4.9-6.2-8-11.5-8c-6.8,0-12.8,5.5-12.8,13.7c0,8.1,6.1,13.8,13.1,13.8 c6.7,0,11.3-4.8,11.8-11.3h-12.2V316h15.6v0.7c0,9.8-6.2,16.2-15.2,16.2c-9,0-16.3-7.2-16.3-16.6c0-9.6,7.1-16.6,16-16.6 c7.7,0,13.4,4.6,15,10.8H1028.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1050.9,300.2h3.1l17.6,26.5v-26.5h3.1v32.1h-3.1l-17.6-26.5l0,26.5h-3.1V300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1116.8,332.3l-3.3-8.8h-14.7l-3.3,8.8h-3.5l12.4-32.1h3.5l12.4,32.1H1116.8z M1112.6,320.7l-6.4-16.9 l-6.4,16.9H1112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1162.1,310.5c-1.5-4.9-6.2-8-11.5-8c-6.8,0-12.8,5.5-12.8,13.7c0,8.1,6.1,13.8,13.1,13.8 c6.7,0,11.3-4.8,11.8-11.3h-12.2V316h15.6v0.7c0,9.8-6.2,16.2-15.2,16.2c-9,0-16.3-7.2-16.3-16.6c0-9.6,7.1-16.6,16-16.6 c7.7,0,13.4,4.6,15,10.8H1162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#241E46",
    d: "M1184.7,300.2h18.4v2.8h-15.2v11.8h13.9v2.8h-13.9v11.9h15.6v2.8h-18.8V300.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M250.3,192.7l-46,103.5c-2.7,6.1-11.3,6.1-14,0l-46-103.5h23.6c4.5,0,8.6,2.8,10.3,7l20,49.7l20.5-50.4 c1.5-3.8,5.2-6.3,9.3-6.3L250.3,192.7z M142.5,219.6l-15.1,78.7h26.2l7.4-37L142.5,219.6z M267.2,298.3l-15.1-78.7l-18.5,41.6 l7.4,37c0,0,0,0,0,0H267.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewieLogoTekstDonker);
export default __webpack_public_path__ + "static/media/viewie-logo-tekst-donker.d6f7fac034531a48c8490fea02c6c325.svg";
export { ForwardRef as ReactComponent };